import { Shark, Utils, View } from "shark-mvc";

import ImageContent from "../../models/ImageContent";
import TextContent from "../../models/TextContent";

import templateContent from "./texts-bulk-insert.html";
import "./style.css";

import autoRelatedContentSuggestionComponent from "../../components/autoRelatedContentSuggestion/autoRelatedContentSuggestionComponent";
import imageContentManager from "../../controllers/imageContentManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import referenceVolumesComponent from "../../components/referenceVolumes/referenceVolumesComponent";
import textContentManager from "../../controllers/textContentManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class TextsBulkInsertView extends View {
	constructor () {
		super("textsBulkInsertView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		referenceVolumesComponent.setup();	
	}

	autoRelatedContentSuggestionComponent_contentAddedHandler () {
		const { currContent } = Shark.get();

		if (currContent) {
			Utils.reindexList(currContent.__renderableRelatedContent);
			currContent.__renderableRelatedContent.forEach(item => item._parentIndex = currContent._index);
			Shark.render();
		}
	}
	
	beforeLoad () {	
		Shark.set({
			bulkTextsList: [],
		});
	}

	bulkUploadField_changeHandler (event) {
		Shark.set({
			bulkImageFileList: Array.from(event.target.files),
		});
	}

	copyAndDiscardTextContentBtn_clickHandler (event, data) {
		this.copyTextContentBtn_clickHandler(event, data);
		this.discardStoryBtn_clickHandler(event, data);
	}

	copyBodyIntoTitleBtn_clickHandler (event, data) {
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			const title = this.purgeTitle(textContent.body);

			textContent.set({
				title,
			});
			
			Shark.render();
		}
	}

	copySelectionToImageTitleBtn_clickHandler (event, data) {
		const textArea = event.target.closest("[data-sh-model]")?.querySelector(`[data-sh-prop="description"]`);
		const selectedText = textArea.value.slice(textArea.selectionStart, textArea.selectionEnd);
		// const selectedText = document.getSelection().getRangeAt(0).toString().trim();
		
		if (selectedText !== "") {
			const { bulkSavedTextContentList } = Shark.get();
			const contentIndex = parseInt(event.target.closest("[data-content-index]").dataset.contentIndex);
			const textContent = bulkSavedTextContentList[contentIndex];

			if (textContent) {
				const relatedContentImage = Utils.safp(textContent.relatedContents, "guid", data.guid);
	
				if (relatedContentImage) {
					relatedContentImage.title = this.purgeTitle(selectedText);
				}
	
				const relatedImage = Utils.safp(textContent.__renderableRelatedContent, "guid", data.guid);
	
				if (relatedImage) {
					relatedImage.set({
						title: this.purgeTitle(selectedText),
					});
				}
	
				Shark.render();
			}
		}
	}

	copySelectionToTextTitleBtn_clickHandler (event, data) {
		const textArea = event.target.closest("tr")?.querySelector(`[data-sh-prop="body"]`);
		const selectedText = textArea.value.slice(textArea.selectionStart, textArea.selectionEnd);

		if (selectedText !== "") {
			const contentIndex = data.index;
			const { bulkSavedTextContentList } = Shark.get();
			const textContent = bulkSavedTextContentList[contentIndex];

			if (textContent) {
				const title = this.purgeTitle(selectedText);

				textContent.set({
					title,
				});
				
				Shark.render();
			}
		}
	}

	copyTextContentBtn_clickHandler (event, data) {
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[data.index];

		if (textContent) {
			navigator.clipboard.writeText(textContent.body);

			event.target.classList.remove("btn-primary");
			event.target.classList.add("btn-success");

			setTimeout(() => {
				event?.target?.classList.remove("btn-success");
				event?.target?.classList.add("btn-primary");
			}, 600);
		}
	}

	discardAllStoriesInPageBtn_clickHandler (event, data) {
		const pageTag = data.page;
		const page = parseInt(pageTag.slice(-3));

		if (page != null && confirm(`Vuoi davvero scartare tutti i contenuti della pagina ${page}?`)) {
			const { bulkSavedTextContentList } = Shark.get();
			const contentToDiscardList = [];

			bulkSavedTextContentList.forEach(textContent => {
				if (textContent.__pageTagsLabel === pageTag) {
					contentToDiscardList.push(textContent);
				}
			});

			contentToDiscardList.forEach(textContent => this.discardStory(textContent));
		}
	}

	discardStory (textContent, index) {
		const { bulkSavedTextContentList, textBulkInsertSettings } = Shark.get();
		
		textContent.set({
			_inDesignExportedStatus: 2,
			_discarded: true,
			_selectedForImport: false,
		});

		bulkSavedTextContentList.splice(index, 1);

		const inDesignExporteListItem = Utils.safp(textBulkInsertSettings.inDesingExportedStoriesList, "guid", textContent._inDesignExportedGuid);
			
		if (inDesignExporteListItem) {
			inDesignExporteListItem.status = 2;
		}

		this.filterAndParseContents();
	}

	discardStoryBtn_clickHandler (event, data) {
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[data.index];

		if (!textContent._selectedForImport || confirm("Hai promosso questo brano per l'importazione, vuoi davvero scartarlo??")) {
			this.discardStory(textContent, data.index);
		}
	}

	filterAndParseContents (fullTextContentsToProcess) {
		const { fullTextContentsToInsert, textBulkInsertSettings } = Shark.get();

		const fullTextList = fullTextContentsToProcess || fullTextContentsToInsert;
		
		if (fullTextList) {

			const textContentsToInsert = fullTextList.filter(item => [1, 4].includes(item._inDesignExportedStatus) || (item._inDesignExportedStatus === 2 && textBulkInsertSettings.showDiscardedContent) || (item._inDesignExportedStatus === 3 && textBulkInsertSettings.showImportedContent));
			
			Utils.reindexList(textContentsToInsert);
			
			textContentsToInsert.forEach(itemToCheckForDupe => {
				itemToCheckForDupe._isDupe = textContentsToInsert.find(dupeCheck => itemToCheckForDupe.body === dupeCheck.body && itemToCheckForDupe._inDesignExportedGuid !== dupeCheck._inDesignExportedGuid) != null;

				itemToCheckForDupe.__renderableRelatedContent.forEach(item => item._parentIndex = itemToCheckForDupe._index);
			});
			
			Shark.set({
				bulkSavedTextContentList: textContentsToInsert,
			});
			
			return textContentsToInsert;
		}
	}
	
	async importTextContentBtn_clickHandler (event, data) {
		waitBoxComponent.open();

		const { bulkSavedTextContentList, textBulkInsertSettings } = Shark.get();
		const textContent = bulkSavedTextContentList[data.index];
		// console.log({textContent});
		
		const saveResponse = await textContentManager.save(textContent);
		// console.log({saveResponse});

		if (saveResponse.status === "ok") {
			for (let currImage of textContent.__renderableRelatedContent) {
				if (currImage.type === "image") {
					const imageToUpdate = new ImageContent(currImage);
					const saveImageResponse = await imageContentManager.save(imageToUpdate);
					console.log({saveImageResponse});
				}
			}

			bulkSavedTextContentList.splice(data.index, 1);
				
			textContent.set({
				_inDesignExportedStatus: 3,
			});

			const inDesignExporteListItem = Utils.safp(textBulkInsertSettings.inDesingExportedStoriesList, "guid", textContent._inDesignExportedGuid);
			
			if (inDesignExporteListItem) {
				inDesignExporteListItem.status = 3; //Importato nel sistema
			}

			// console.log("textBulkInsertSettings.inDesingExportedStoriesList", textBulkInsertSettings.inDesingExportedStoriesList);
			Utils.reindexList(bulkSavedTextContentList);
			
			Shark.set({
				bulkSavedTextContentList,
			});

			waitBoxComponent.close();
		}
	}

	inDesingExportedStoriesListFileField_changeHandler (event) {
		const { textBulkInsertSettings } = Shark.get();
		const file = event.target.files[0];
		const fileReader = new FileReader();

		fileReader.addEventListener("load", () => {
			const inDesingExportedStoriesList = JSON.parse(fileReader.result);

			if (!inDesingExportedStoriesList?.[0].guid) {
				inDesingExportedStoriesList.forEach(item => {
					item.guid = Shark.__generateGUID();
					item.status = 1;
				});
			}

			textBulkInsertSettings.set({
				inDesingExportedStoriesList,
				inDesingExportedStoriesListRaw: JSON.stringify(inDesingExportedStoriesList, "", "  "),
			});

			Shark.set({
				lastInDesignExportedStoriesListFileName: file.name,
			});
		});

		fileReader.readAsText(file);
	}

	init () {
		this.addComponents([autoRelatedContentSuggestionComponent, mainNavComponent, referenceVolumesComponent, waitBoxComponent]);

		const textBulkInsertSettingsRawData = localStorage.textBulkInsertSettings;
		let textBulkInsertSettingsData;

		if (textBulkInsertSettingsRawData) {
			textBulkInsertSettingsData = JSON.parse(textBulkInsertSettingsRawData);
		}

		const textBulkInsertSettings = Shark.getInstance("__smart__", {
			inDesingExportedStoriesList: [],
			inDesingExportedStoriesListRaw: "",
			referenceVolumeRaw: "",

			__referenceVolumes: "",
			referenceVolumeGuids: "",

			copyTextContentBtnCSSClass: "btn-primary",

			showDiscardedContent: textBulkInsertSettingsData ? textBulkInsertSettingsData.showDiscardedContent : false,
			showImportedContent: textBulkInsertSettingsData ? textBulkInsertSettingsData.showImportedContent : false,
		});

		textBulkInsertSettings.on("dataChanged", (event, data) => {
			console.log("textBulkInsertSettings.dataChanged", data);

			localStorage.textBulkInsertSettings = JSON.stringify(textBulkInsertSettings);

			if (data.property === "__referenceVolumes") {
				const { referencevolumeList } = Shark.get();

				if (referencevolumeList) {
					const tag = data.newValue.replace("[{\"value\":\"", "").replace("\"}]", "");
					const volume = referencevolumeList.find(item => tag === `${item.number.toString().padStart(2, "0")} ${item.title}`);

					console.log({volume});
					
					if (volume) {
						textBulkInsertSettings.set({
							referenceVolumeGuids: [volume.guid],
						});
					}
				}
			}
			if (["showDiscardedContent", "showImportedContent"].includes(data.property)) {
				this.filterAndParseContents();
			}
		});

		Shark.set({
			bulkTextsList: [],
			bulkSavedTextContentList: [],
			textBulkInsertSettings,
			inDesingExportedImageList: [],
		});
	}

	async pasteAsImageDescriptionBtn_clickHandler (event, data) {
		const clipboardContent = await navigator.clipboard.readText();
		const contentIndex = parseInt(event.target.closest("[data-content-index]").dataset.contentIndex);
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			const relatedContentImage = Utils.safp(textContent.relatedContents, "guid", data.guid);

			if (relatedContentImage && relatedContentImage.title === "") {
				relatedContentImage.title = this.purgeTitle(clipboardContent);
			}

			const relatedImage = Utils.safp(textContent.__renderableRelatedContent, "guid", data.guid);

			if (relatedImage) {
				relatedImage.set({
					description: this.purgeTitle(clipboardContent),
				});
			}

			Shark.render();
		}
	}

	async pasteAsImageTitleBtn_clickHandler (event, data) {
		const clipboardContent = await navigator.clipboard.readText();
		const contentIndex = parseInt(event.target.closest("[data-content-index]").dataset.contentIndex);
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			const relatedContentImage = Utils.safp(textContent.relatedContents, "guid", data.guid);

			if (relatedContentImage) {
				relatedContentImage.title = this.purgeTitle(clipboardContent);
			}

			const relatedImage = Utils.safp(textContent.__renderableRelatedContent, "guid", data.guid);

			if (relatedImage) {
				relatedImage.set({
					title: this.purgeTitle(clipboardContent),
				});
			}

			Shark.render();
		}
	}

	async pasteAsTitleBtn_clickHandler (event, data) {
		const clipboardContent = await navigator.clipboard.readText();
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		textContent.set({
			title: this.purgeTitle(clipboardContent),
		});

		Shark.render();
	}

	async pasteAsSubitleBtn_clickHandler (event, data) {
		const clipboardContent = await navigator.clipboard.readText();
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		textContent.set({
			subtitle: clipboardContent,
		});

		Shark.render();
	}

	async pasteAsAbstractBtn_clickHandler (event, data) {
		const clipboardContent = await navigator.clipboard.readText();
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		textContent.set({
			abstract: clipboardContent,
		});

		Shark.render();
	}

	async processStories () {
		const { textBulkInsertSettings } = Shark.get();

		if (textBulkInsertSettings.referenceVolumeRaw.trim() === "") {
			alert("Devi inserire un volume di riferimento");
			return;
		}

		if (textBulkInsertSettings.inDesingExportedStoriesListRaw.trim() === "") {
			alert("Devi inserire la lista delle immagini da InDesing.");
			return;
		}

		waitBoxComponent.open();

		const referenceVolume = textBulkInsertSettings.referenceVolumeRaw.trim();

		const fullTextContentsToInsert = textBulkInsertSettings.inDesingExportedStoriesList.filter(item => item.story.trim().length > 0).map(item => {
			return new TextContent({
				body: item.story,
				extraData: {
					needReview: true,
				},
				referenceVolumes: [{ value: referenceVolume }],
				referenceVolumeGuids: [textBulkInsertSettings.referenceVolumeGuids],
				status: 1,
				tags: `[{"source": "automation", "type": "page-number", "value":"pag${item.page.toString().padStart(3, "0")}"}]`,
				_inDesignExportedGuid: item.guid,
				_inDesignExportedStatus: item.status,
			});
		});
		
		const textContentsToInsert = this.filterAndParseContents(fullTextContentsToInsert);

		Shark.set({
			bulkSavedTextContentList: textContentsToInsert,
			fullTextContentsToInsert,
		});

		waitBoxComponent.close();
	}
	
	processStoriesBtn_clickHandler () {
		this.processStories();
	}

	promoteStoryBtn_clickHandler (event, data) {
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			textContent.set({
				_discarded: false,
				_inDesignExportedStatus: 4,
				_selectedForImport: true,
			});

			Shark.render();
		}
	}

	purgeTitle (text) {
		let purgedText = text.trim().replace(/<br>/gi, " ").replace("| ", "");
		
		while (purgedText.indexOf("  ") > -1) {
			purgedText = purgedText.replace(/ {2}/gi, " ");
		}

		return purgedText.slice(0, 1).toUpperCase() + purgedText.slice(1);
	}

	recoverDiscardedStoryBtn_clickHandler (event, data) {
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			textContent.set({
				_discarded: false,
				_inDesignExportedStatus: 1,
			});

			Shark.render();
		}
	}

	removeRelateImageBtn_clickHandler (event, data) {
		const { bulkSavedTextContentList } = Shark.get();
		const contentIndex = parseInt(event.target.closest("[data-content-index]").dataset.contentIndex);
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			textContent.set({
				relatedContents: textContent.relatedContents.filter(item => item.guid !== data.guid),
				__renderableRelatedContent: textContent.__renderableRelatedContent.filter(item => item.guid !== data.guid),
			});

			Shark.render();
		}
	}

	retrieveSuggestedRelatedContentBtn_clickHandler (event, data) {
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		Shark.set({
			currContent: textContent,
		});

		autoRelatedContentSuggestionComponent.retrieveSuggestedRelatedContent(textContent, ["image"]);
	}

	saveLastProcessReportBtn_clickHandler () {
		this.saveUploadReport();
	}

	saveStoriesListBtn_clickHandler () {
		const { lastInDesignExportedStoriesListFileName, textBulkInsertSettings } = Shark.get();
		
		if (lastInDesignExportedStoriesListFileName && textBulkInsertSettings) {
			const link = document.createElement("a");
			const file = new Blob([JSON.stringify(textBulkInsertSettings.inDesingExportedStoriesList)], { type: "application/json" });
			link.href = URL.createObjectURL(file);
			link.download = lastInDesignExportedStoriesListFileName;
			link.click();
			URL.revokeObjectURL(link.href);
			link.remove();
		}
	}

	saveUploadReport () {
		const { lastInDesignExportedStoriesListFileName, uploadReportData } = Shark.get();

		if (uploadReportData) {
			const link = document.createElement("a");
			const file = new Blob([JSON.stringify(uploadReportData)], { type: "application/json" });
			link.href = URL.createObjectURL(file);
			link.download = lastInDesignExportedStoriesListFileName.replace(".txt", " - report.json");
			link.click();
			URL.revokeObjectURL(link.href);
			link.remove();
		}
	}

	useBodyAsTitleBtn_clickHandler (event, data) {
		const contentIndex = data.index;
		const { bulkSavedTextContentList } = Shark.get();
		const textContent = bulkSavedTextContentList[contentIndex];

		if (textContent) {
			const title = this.purgeTitle(textContent.body);

			textContent.set({
				body: "",
				title,
			});
			
			Shark.render();
		}
	}
}

const textsBulkInsertView = new TextsBulkInsertView();

Shark.registerView(textsBulkInsertView);

export default textsBulkInsertView;